import { GET_USER_LOCALE } from '../components/App.gql';
export var formatPriceToParts = function (price, currencyCode) {
    var _a;
    var parts = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode
    }).formatToParts(Number(price));
    var currency = ((_a = parts.find(function (part) { return part.type === 'currency'; })) === null || _a === void 0 ? void 0 : _a.value) || '';
    var amount = parts
        .filter(function (part) { return part.type !== 'currency'; })
        .map(function (part) { return part.value; })
        .join('')
        .replace(/\.00$/, '');
    return [currency, amount];
};
export var formatPrice = function (price, currencyCode) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode
    })
        .format(Number(price))
        .replace(/\.00$/, '');
};
export var getUserCountry = function (apolloClient) {
    var _a;
    var user = apolloClient.readQuery({
        query: GET_USER_LOCALE
    }).user;
    return (_a = user === null || user === void 0 ? void 0 : user.locale) === null || _a === void 0 ? void 0 : _a.country;
};
export var getCurrencySymbol = function (country) {
    if (country === 'CA') {
        return 'CA$';
    }
    return '$';
};
export default {};
